import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const PressReleasesServiceContext = createContext(undefined)

const PressReleasesServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={PressReleasesServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api/v1/content/press_releases`, payload)
          return data
        },
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/content/press_releases/${id}`)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/content/press_releases${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/content/press_releases/${id}`, payload)
          return data
        },
        delete: async (id) => {
          const {data} = await axios.delete(`/api/v1/content/press_releases/${id}`)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

PressReleasesServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const usePressReleasesService = () => {
  const context = useContext(PressReleasesServiceContext)
  if (context === undefined) {
    throw new Error('PressReleasesServiceContext was not provided. Make sure your component is a child of the PressReleasesServiceProvider.')
  }
  return context
}

const usePressReleasesQuery = ({query, ...otherProps}) => {
  const pressReleasesService = usePressReleasesService()
  return useSimpleQuery({
    queryKey: `press_releases-list-${JSON.stringify(query)}`,
    queryFn: async () => pressReleasesService.list(query),
    ...otherProps
  })
}

const usePressReleaseQuery = ({id, enabled, ...otherProps}) => {
  const pressReleasesService = usePressReleasesService()
  return useSimpleQuery({
    queryKey: `press_releases-get-${id}`,
    queryFn: async () => pressReleasesService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {PressReleasesServiceProvider, usePressReleasesService, usePressReleasesQuery, usePressReleaseQuery}
